import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { PublicClientApplication } from '@azure/msal-browser';
import { MSAL_INSTANCE, MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';

import { routes } from './app.routes';
import { msalBrowserConfig } from './auth/auth.config';
import { SessionService } from './services/session.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch()),
    provideRouter(routes),
    {
      provide: MSAL_INSTANCE,
      useFactory: () => new PublicClientApplication(msalBrowserConfig)
    },
    MsalBroadcastService,
    MsalService,
    SessionService,
    provideAppInitializer(() => firstValueFrom(inject(SessionService).initialize()))
  ]
};
